import { useSelector } from "react-redux"
import useSWR from "swr"
import { StaffApi, VehicleApi } from "../../../apis"
import { IAuth } from "../../../store/Auth"
import { renderName } from "../../../utils/render-name"
import { usePermission } from "../../permission"

export type PickerOption = { value: string; label: string }

/** Drivers for «Жолооч хуваарилах»: /ord/staff/select (ORD_LIST), names only. */
export function useDriverOptions(enabled: boolean) {
  const businessId = useSelector((s: { auth: IAuth }) => s.auth.user?.currentBusinessId ?? null)
  const ORD_LIST = usePermission("ORD_LIST")
  const allowed = enabled && !!businessId && ORD_LIST.hasAccess
  const swr = useSWR(allowed ? ["inbound.drivers", businessId] : null, () => StaffApi.select({ businessId: businessId as string, limit: 200 }), {
    revalidateOnFocus: false,
  })
  const options: PickerOption[] = (swr.data ?? []).map((s) => ({ value: s.id, label: renderName(s) || "-" }))
  return { options, isLoading: swr.isLoading, permissionReason: ORD_LIST.reason }
}

/** Vehicles for the optional vehicle select: /ord/vehicle/list (BIZ_GOV_VIEW), plate number first. */
export function useVehicleOptions(enabled: boolean) {
  const BIZ_GOV_VIEW = usePermission("BIZ_GOV_VIEW")
  const allowed = enabled && BIZ_GOV_VIEW.hasAccess
  const swr = useSWR(allowed ? ["inbound.vehicles"] : null, () => VehicleApi.list({ filter: { isActive: true }, offset: { limit: 100, skip: 0 } }), {
    revalidateOnFocus: false,
  })
  const options: PickerOption[] = (swr.data?.rows ?? []).map((v) => ({
    value: v.id,
    label: [v.plateNumber, [v.make, v.model].filter(Boolean).join(" ")].filter(Boolean).join(" · "),
  }))
  return { options, isLoading: swr.isLoading, permissionReason: BIZ_GOV_VIEW.reason }
}
